
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

interface FAQ {
  question: string;
  answer: string;
  category: string;
}

export default function FAQPage() {
  const [activeCategory, setActiveCategory] = useState('الكل');
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const categories = ['الكل', 'القبول', 'الاختبارات', 'الرسوم', 'التخصصات', 'السكن'];

  const faqs: FAQ[] = [
    {
      question: 'ما هي شروط القبول في الجامعات السعودية؟',
      answer: 'تختلف شروط القبول من جامعة لأخرى، لكن بشكل عام تشمل: شهادة الثانوية العامة بمعدل محدد، اجتياز اختبار القدرات العامة، اختبار التحصيلي للتخصصات العلمية، واستيفاء أي شروط إضافية تحددها الجامعة.',
      category: 'القبول'
    },
    {
      question: 'متى تبدأ فترة التسجيل في الجامعات؟',
      answer: 'عادة تبدأ فترة التسجيل في الجامعات السعودية في شهر شعبان وتستمر حتى شهر شوال من كل عام. ننصح بمتابعة منصتنا للحصول على التحديثات الدقيقة لكل جامعة.',
      category: 'القبول'
    },
    {
      question: 'ما هو اختبار القدرات العامة؟',
      answer: 'اختبار القدرات العامة هو اختبار يقيس القدرات التحليلية والاستدلالية لدى الطالب. يتكون من جزأين: لفظي (لغوي) وكمي (رياضي). يُعقد الاختبار من قبل المركز الوطني للقياس.',
      category: 'الاختبارات'
    },
    {
      question: 'هل اختبار التحصيلي إلزامي لجميع التخصصات؟',
      answer: 'اختبار التحصيلي مطلوب بشكل أساسي للتخصصات العلمية والصحية والهندسية. أما التخصصات الأدبية والإنسانية فقد لا تتطلبه، لكن يُفضل التأكد من متطلبات كل جامعة.',
      category: 'الاختبارات'
    },
    {
      question: 'كم تبلغ رسوم الدراسة في الجامعات الأهلية؟',
      answer: 'تتراوح رسوم الدراسة في الجامعات الأهلية بين 30,000 إلى 80,000 ريال سنوياً حسب التخصص والجامعة. بعض الجامعات تقدم منح دراسية وتخفيضات للطلاب المتفوقين.',
      category: 'الرسوم'
    },
    {
      question: 'هل توجد منح دراسية متاحة؟',
      answer: 'نعم، تقدم العديد من الجامعات السعودية منح دراسية كاملة أو جزئية للطلاب المتفوقين. كما توجد منح خاصة للطلاب ذوي الدخل المحدود والمتفوقين رياضياً.',
      category: 'الرسوم'
    },
    {
      question: 'ما هي التخصصات الأكثر طلباً في سوق العمل؟',
      answer: 'التخصصات الأكثر طلباً حالياً تشمل: علوم الحاسب والذكاء الاصطناعي، الهندسة بأنواعها، الطب والتخصصات الصحية، إدارة الأعمال والتسويق، والأمن السيبراني.',
      category: 'التخصصات'
    },
    {
      question: 'هل يمكن تغيير التخصص بعد القبول؟',
      answer: 'نعم، معظم الجامعات تسمح بتغيير التخصص خلال السنة الأولى بشروط معينة، مثل تحقيق معدل تراكمي محدد وتوفر مقاعد في التخصص المطلوب.',
      category: 'التخصصات'
    },
    {
      question: 'هل توفر الجامعات سكناً للطلاب؟',
      answer: 'نعم، معظم الجامعات الحكومية توفر سكناً جامعياً للطلاب والطالبات بأسعار رمزية أو مجاناً. أما الجامعات الأهلية فبعضها يوفر سكناً برسوم إضافية.',
      category: 'السكن'
    },
    {
      question: 'ما هي مميزات السكن الجامعي؟',
      answer: 'السكن الجامعي يوفر بيئة دراسية مناسبة، قرب من الحرم الجامعي، خدمات النقل، مرافق رياضية وترفيهية، وأمن على مدار الساعة. كما يساعد على بناء علاقات اجتماعية مع الزملاء.',
      category: 'السكن'
    }
  ];

  const filteredFAQs = activeCategory === 'الكل' 
    ? faqs 
    : faqs.filter(faq => faq.category === activeCategory);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-primary-900 via-primary-800 to-primary-900 pt-32 pb-24">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}></div>
        </div>
        
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 font-cairo">
            الأسئلة الشائعة
          </h1>
          <p className="text-xl text-white/90 font-tajawal">
            إجابات على أكثر الأسئلة شيوعاً حول القبول الجامعي
          </p>
        </div>
      </div>

      {/* FAQ Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="space-y-4">
          {filteredFAQs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md overflow-hidden transition-all hover:shadow-lg"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between cursor-pointer text-right"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-full flex-shrink-0">
                    <i className="ri-question-line text-primary-700 text-xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 font-cairo">
                    {faq.question}
                  </h3>
                </div>
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-gray-400 transition-transform`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6 pr-[88px]">
                  <p className="text-gray-600 font-tajawal leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}
